const getStorageSize = (bytes: number): string => {
	const size = bytes * 0.001;
	if (size < 1) return bytes + 'B';
	if (size > 1000000000) return Math.round(size * 0.001 * 10) / 10 + 'TB';
	if (size > 1000000) return Math.round(size * 0.001 * 10) / 10 + 'GB';
	if (size > 1000) return Math.round(size * 0.001 * 10) / 10 + 'MB';
	return Math.round(size) + 'KB';
};

export default getStorageSize;
